import React, { useState, useCallback, useEffect } from 'react';
import {
  TextField,
  InputAdornment,
  Tooltip,
  Popper,
  Fade,
  MenuItem,
  Typography,
} from '@mui/material';
import { ArrowDropDownRounded, Search } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import debounce from '@src/utils/debounce';
import { useClickOutside } from '@src/hooks/useClickOutSide';
import SortRoundedIcon from '@mui/icons-material/SortRounded';
import {
  StyledIconButton,
  StyledPaper,
  StyledVoiceFilterAction,
} from './index.style';
import ButtonAction from './ButtonAction';

const VoiceFilterAction = ({
  filter = {},
  setSearch,
  onChangeFilter,
  search,
  optionsFilter,
  sort,
  onSort,
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState(filter.search || '');
  const [popperAnchorElement, setPopperAnchorElement] = useState(null);
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const popperContainerRef = useClickOutside(() => {
    setIsPopperOpen(false);
  });
  const debouncedHandleSearch = useCallback(
    debounce((value) => {
      setSearch(value);
      onChangeFilter({ ...filter, search: value });
    }, 500),
    [setSearch, onChangeFilter, filter],
  );

  const handleChangeSearch = (e) => {
    const { value } = e.target;
    setSearchTerm(value);
    debouncedHandleSearch(value);
  };

  useEffect(() => {
    if (search === '') setSearchTerm('');
  }, [search]);

  return (
    <StyledVoiceFilterAction>
      <div className="header-sort-voice">
        <TextField
          size="small"
          value={searchTerm}
          className="search-voice"
          placeholder={t('voiceSearch')}
          onChange={handleChangeSearch}
          InputLabelProps={{
            style: { color: 'white' },
          }}
          sx={{
            '.css-19xwh20-MuiInputBase-root-MuiOutlinedInput-root': {
              borderRadius: '8px',
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search className="img-search" />
              </InputAdornment>
            ),
          }}
        />
        <div ref={popperContainerRef}>
          <StyledIconButton
            height="42px"
            onClick={(e) => {
              setPopperAnchorElement(e.currentTarget);
              setIsPopperOpen((prev) => !prev);
            }}
            borderRadius="8px"
            isDisableHover
          >
            <Tooltip
              arrow
              title={optionsFilter[sort] || t('recommend')}
              placement="top"
            >
              <div className="wrap_btn">
                <SortRoundedIcon className="icon" />{' '}
                <Typography className="sort-text">
                  {t(optionsFilter[sort]) || t('recommend')}
                </Typography>
                <ArrowDropDownRounded />
              </div>
            </Tooltip>
            <Popper
              transition
              style={{
                zIndex: 9999,
                width: '200px',
                color: '#1E164E',
              }}
              anchorEl={popperAnchorElement}
              open={isPopperOpen}
              placement="bottom-start"
              modifiers={[
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  },
                },
              ]}
            >
              {({ TransitionProps }) => (
                <Fade
                  style={{ padding: '4px 0px' }}
                  {...TransitionProps}
                  timeout={350}
                >
                  <StyledPaper>
                    {Object.keys(optionsFilter)?.map((option) => (
                      <MenuItem
                        key="recently"
                        className="option_filter"
                        style={{
                          color: '#1E164E',
                          fontSize: '14px',
                          height: '40px',
                          boxSizing: 'border-box',
                          padding: '10px 16px 10px 16px',
                          fontWeight: 400,
                          background: option === sort && '#1E164E14',
                        }}
                        onMouseEnter={(e) => {
                          if (option === sort) return;
                          e.currentTarget.style.backgroundColor = '#1E164E14';
                        }}
                        onMouseLeave={(e) => {
                          if (option === sort) return;
                          e.currentTarget.style.backgroundColor = '';
                        }}
                        onClick={() => {
                          onSort(option);
                          setPopperAnchorElement(null);
                          setIsPopperOpen((prev) => !prev);
                        }}
                      >
                        {optionsFilter[option]}
                      </MenuItem>
                    ))}
                  </StyledPaper>
                </Fade>
              )}
            </Popper>
          </StyledIconButton>
        </div>
      </div>
      <ButtonAction search={filter} name="provider" onChange={onChangeFilter} />
    </StyledVoiceFilterAction>
  );
};

export default VoiceFilterAction;
